import { ReactNode } from 'react';
import parse, { domToReact, DOMNode } from 'html-react-parser';

// Import styles
import { Item, ItemImage, Channels, Description, IconTick, ButtonsWrapper } from './styles';

// Import types
import { ImageType } from 'types/api/images';

// Import helpers
import { getImage } from 'helpers/images';

// Import hooks
import { usePremiumPacketContext } from 'components/context/premium_packet/PremiumPacketProvider';

// Import components
import { PacketButton } from './PacketButton';

type Props = {
	children: ReactNode;
	showButton?: boolean;
	isDisabled?: boolean;
};

export const Packet = ({ children, showButton = true, isDisabled }: Props) => {
	const {
		packet: { title, channels, images, short_desc }
	} = usePremiumPacketContext();

	const image = getImage(images, [ImageType.Cover]);

	const channelsTitles = channels.map((packet) => packet.title).join(', ');

	return (
		<Item>
			<div>
				<ItemImage src={image} alt={title} />
				<Channels>Dostęp do kanałów: {channelsTitles}</Channels>
				<Description>
					{parse(short_desc, {
						replace: (domNode) => {
							if (domNode.type === 'tag' && domNode.name === 'li') {
								return (
									<li>
										<IconTick />
										{domToReact(domNode.children as DOMNode[])}
									</li>
								);
							}
						}
					})}
				</Description>
			</div>

			<ButtonsWrapper>
				{children}

				{showButton && <PacketButton isDisabled={isDisabled} />}
			</ButtonsWrapper>
		</Item>
	);
};
